var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;fill-rule:evenodd;}")),React.createElement("title",{"key":1},"right-arrow"),React.createElement("g",{"id":"New","key":2},React.createElement("g",{"id":"Home-Page"},React.createElement("g",{"id":"Group-7"},React.createElement("g",{"id":"Group-6"},React.createElement("g",{"id":"Group-8"},React.createElement("g",{"id":"Group"},React.createElement("polygon",{"id":"Fill-1-Copy-2","className":"cls-1","points":"7.4 0 6.38 1.24 11.28 7.22 0.03 7.11 0 8.71 10.99 8.71 6.38 14.33 7.4 15.57 13.79 7.82 13.76 7.79 12.77 6.58 7.4 0"})))))))]);
}

RightArrow.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 13.79 15.57"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
